import React, {useEffect, useRef} from "react";
import './Jackpots.css'

export default function Jackpot(props) {
    const audioRef = useRef(null);
 useEffect(() => {
    const a = audioRef.current;
    if (!a) return;
    a.play();

  }, []);

  return (
    <div className='contJacpot'>
      <div className='gridJacpot'>
        <div className='textJack'>Jackpot</div>
        <div className='textTipo'>
          <spam className='textLcl'>Local</spam>
          </div>
        <div className='textMonto'>$ {props.value||100000}</div>
        <div className='textTicket'>Ticket: {props.ticket}</div>
      </div>
    <div >
      <audio ref={audioRef} src={'/jp.wav'} preload="auto" autoPlay loop/>
    </div>
    </div>
  );
}
